var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6562 15.3438V13.0938H9.40625C8.91406 13.0938 8.5625 12.7422 8.5625 12.25C8.5625 11.793 8.91406 11.4062 9.40625 11.4062H11.6562V9.15625C11.6562 8.69922 12.0078 8.3125 12.5 8.3125C12.957 8.3125 13.3438 8.69922 13.3438 9.15625V11.4062H15.5938C16.0508 11.4062 16.4375 11.793 16.4375 12.25C16.4375 12.7422 16.0508 13.0938 15.5938 13.0938H13.3438V15.3438C13.3438 15.8359 12.957 16.1875 12.5 16.1875C12.0078 16.1875 11.6562 15.8359 11.6562 15.3438ZM21.5 12.25C21.5 17.2422 17.457 21.25 12.5 21.25C7.50781 21.25 3.5 17.2422 3.5 12.25C3.5 7.29297 7.50781 3.25 12.5 3.25C17.457 3.25 21.5 7.29297 21.5 12.25ZM12.5 4.9375C8.45703 4.9375 5.1875 8.24219 5.1875 12.25C5.1875 16.293 8.45703 19.5625 12.5 19.5625C16.5078 19.5625 19.8125 16.293 19.8125 12.25C19.8125 8.24219 16.5078 4.9375 12.5 4.9375Z",
    fill: "#FCFDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.3eafa2c9128db02f68cf637c2770daa5.svg";
export { ForwardRef as ReactComponent };